<template>
    <div>
         <p class="productnotfound">
            <img :src="itemnotfound" class="productnotfoundimg">
            <span style="font-size: 2rem;">No results found.</span>
            <br>
            <span style="color:#778899;">Your search was too specific, please try searching with another term.</span>
         </p>
    </div>
</template>


<script>
import itemnotfound from "../assets/images/itemnotfound.png"

export default {
    name:"SearchNotFound",
    data() {
       return {
          itemnotfound
       }
    }
}
</script>